import request from '@/config/axios'
export const getRouters = (): Promise<IResponse<list>> => {
  return request.get({ url: '/admin/index' })
}
